import { render, staticRenderFns } from "./invoiceTitle.vue?vue&type=template&id=0b826c5e&scoped=true&"
import script from "./invoiceTitle.vue?vue&type=script&lang=js&"
export * from "./invoiceTitle.vue?vue&type=script&lang=js&"
import style0 from "./invoiceTitle.vue?vue&type=style&index=0&id=0b826c5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b826c5e",
  null
  
)

export default component.exports